<template>
    <div>
        <header id="header">
            <div class="inner">
                <div class="col col1">
                    <a class="btnNavi prev">
                        <span @click.stop.prevent="backBtn" class="ico">이전</span>
                    </a>
                </div>
                <div class="col col2">
                    <h1>{{ receiptName }}</h1>
                </div>
                <!-- <div class='btnNavi home' @click="appMoveMain()">
    <div class="ico">홈</div>
</div> -->
            </div>
        </header>
        <ReceiptComponent ref="receiptContent" @saveAsImage="saveAsImage" @setReceiptName="setReceiptName"/>
    </div>
</template>

<script>
import ReceiptComponent from '@/components/Receipt/ReceiptComponent.vue'
import ReceiptMixins from '@/utils/ReceiptMixins'

export default {
  components: { ReceiptComponent },
  mixins: [ReceiptMixins],
  data () {
    return {
      receiptName: '영수증',
    }
  },
  methods: {
    backBtn () {
      const backUrl = this.$store.getters.backUrl
      if (backUrl) {
        this.$router.push({
          name: backUrl,
          params: { isBillHistory: true }
        })
      } else {
        this.$router.back()
      }
    },
    setReceiptName (receiptName) {
      this.receiptName = receiptName
    }

  }
}
</script>

<style scoped>
:root,
body {
    font-size: 10px !important;
    line-height: 1;
}

#header{
    height: 5.6rem;
}

@media (max-width: 359.8px) {

    :root,
    body {
        font-size: 8.75px !important;
    }
}
</style>

<style lang="scss" scoped>
.receipt {
    margin: 0 auto;
    background: white;
    padding: 1.6rem;
    padding-top: 7.2rem;

    .header {
        text-align: center;
        margin-bottom: 1.6rem;
    }

    .store-name {
        font-size: 2rem;
        color: #0d0d0d;
        text-align: left;
        font-weight: bold;
        margin-bottom: 1.6rem;
        line-height: 1.5;
    }

    .amount {
        font-size: 2.8rem;
        font-weight: bold;
        color: var(--primary);
        padding-bottom: 2.4rem;
        border-bottom: 1px solid #0d0d0d;
        height: 100%;
        text-align: left;
    }

    .section {
        margin-bottom: 3.2rem;
        padding-bottom: 3.2rem;
        border-bottom: 1px solid #0d0d0d;

        &.seller-info {
            border: none;
            margin-bottom: 0;
        }

        .section-title {
            font-weight: bold;
            color: #333;
            padding-top: 0;
            text-align: left;
            font-size: 1.6rem;
        }

        .info-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0.8rem;
            min-height: 2.4rem;
            gap: 0.8rem;

            &.divider {
                border-bottom: 1px dotted #707070;
                padding-top: 0.8rem;
                margin-bottom: 1.6rem;
                min-height: 0;
                opacity: 0.4;
            }

            .info-label {
                color: #666;
                font-size: 1.6rem;
            }

            .info-value {
                color: #333;
                font-size: 1.6rem;
                font-weight: 500;
                text-align: right;
                word-break: keep-all
            }

            &:last-of-type {
                margin-bottom: 0;
            }
        }

        &.store-info,
        &.seller-info {
            text-align: left;

            .section-title{
                padding-bottom: 1.6rem;
            }

            .info-row {
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                margin-bottom: 0.8rem;
                min-height: 2rem;
                gap: 0;

                .info-label {
                    font-weight: 500;
                    min-width: 4rem;
                    font-size: 1.4rem;
                }

                .info-value {
                    color: #666;
                    font-weight: normal;
                    margin-left: 0.4rem;
                    font-size: 1.4rem;
                }

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }

    .buttons {
        display: flex;
        gap: 1rem;
        margin-top: 0;

        .btn {
            flex: 1;
            padding: 1rem 1.6rem;
            border: 1px solid #ddd;
            background: white;
            cursor: pointer;
            font-size: 1.5rem;
            transition: all 0.2s;

            &.btn-primary {
                color: #0d0d0d;
                border: 1px solid #ddd;

            }
        }
    }
}

.label-highlight {
    color: var(--primary) !important;
    font-size: 1.6rem !important;
    font-weight: bold !important;
}

.break-all{
    word-break: break-all !important;
}

.fs-18 {
    font-size: 1.8rem !important;
}
</style>
